<script setup lang="ts">
import { ref, PropType } from 'vue';
import type { Address } from "@/types/locality/Address";

const props = defineProps({
  addresses: {
    type: Array as PropType<Address[]>,
    required: true
  }
});

const emit = defineEmits({
  addressChosen: (address: Address | null) => true
});

const isModalShown = ref(true);

function formatAddress(address: Address): string {
  return `${address.prefecture} ${address.city} ${address.town}`;
}

function onClickAddress(address: Address) {
  emit("addressChosen", address);
}

function onCancel() {
  emit("addressChosen", null);
}
</script>

<template>
  <BModal
    v-model="isModalShown"
    title="該当する住所を選択してください"
    size="lg"
    content-class="address-modal"
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    centered
    @hide="onCancel"
  >
    <div class="address-list">
      <div
        v-for="address in props.addresses"
        :key="address.id"
        class="address-item"
        @click="onClickAddress(address)"
      >
        <div class="address-text">
          {{ formatAddress(address) }}
        </div>
      </div>
    </div>
  </BModal>
</template>

<style lang="scss" scoped>
.address-modal {
  :deep(.modal-header) {
    border-bottom: 2px solid #e9ecef;
  }
}

.address-list {
  max-height: 400px;
  padding: 1rem;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
}

.address-list-header {
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 500;
  color: #6c757d;
}

.address-item {
  padding: 1.25rem;
  margin-bottom: 0.75rem;
  cursor: pointer;
  background-color: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f8f9fa;
    box-shadow: 0 2px 8px rgb(0 0 0 / 10%);
    transform: translateY(-2px);
  }

  .address-text {
    font-size: 0.95rem;
    line-height: 1.5;
    color: #2c3e50;
  }
}
</style>
